import React, {useRef} from "react"
import {FormControl, FormErrorMessage, FormLabel, InputGroup} from "@chakra-ui/react"
import {DocumentIcon} from "@heroicons/react/24/solid"

import {readFile} from "@utils/helpers"

type FileUploadProps = {
    label?: string,
    field: string,
    accept?: string,
    register: any
    errors?: any,
    onFinish: (records: any[]) => void
}

export function FileUpload(props: FileUploadProps) {

    const {label, field, accept, register, errors, onFinish} = props
    const inputRef = useRef<HTMLInputElement | null>(null)

    const {ref, ...rest} = register(field, {
        validate: validateFiles,
        onChange: (e) => {
            const {files} = e.target
            onFileUpload(files[0])
        }
    })

    const handleClick = () => inputRef.current?.click()

    function onFileUpload(file: File) {
        readFile(file).then(onFinish)
    }

    function validateFiles(value: FileList): boolean | string {
        if (!value.length) {
            return true
        }

        const file = value[0]
        const fsMb = file.size / (1024 * 1024)
        const MAX_FILE_SIZE = 10
        if (fsMb > MAX_FILE_SIZE) {
            return "Max file size 10mb"
        }

        return true
    }


    return (
        <FormControl isInvalid={errors[field]}>
            {label &&
              <FormLabel htmlFor={field}>{label}</FormLabel>}

            <InputGroup onClick={handleClick}>
                <div
                    className="w-full mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
                    <div className="text-center">
                        <DocumentIcon className="mx-auto h-12 w-12 text-gray-300" aria-hidden="true"/>
                        <div className="mt-4 flex text-sm leading-6 text-gray-600">
                            <label
                                htmlFor="file-upload"
                                className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                            >
                                <span>Upload a .CSV file</span>
                                <input
                                    type="file"
                                    accept={accept}
                                    className="sr-only"
                                    {...rest}
                                    ref={(e) => {
                                        ref(e)
                                        inputRef.current = e
                                    }}
                                />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                        </div>
                        <p className="text-xs leading-5 text-gray-600">CSV up to 10MB</p>
                    </div>
                </div>
            </InputGroup>

            <FormErrorMessage>
                {errors[field] && errors[field].message}
            </FormErrorMessage>
        </FormControl>
    )
}
